var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-logo"},[_c('router-link',{attrs:{"to":{name:'/'}}},[_c('LogoSvg',{attrs:{"width":"32","height":"32"}}),(!_vm.sidebarCollapsed || _vm.layout === 'top')?_c('h1',[_vm._v(_vm._s(_vm.projectTitle))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }